export const ideaViewsQueryKeys = {
  all: () => ['/idea-views'] as const,
  lists: () => [...ideaViewsQueryKeys.all(), 'list'] as const,
  list: (params: Record<string, unknown>) =>
    [...ideaViewsQueryKeys.lists(), JSON.stringify(params)] as const,
  detail: (id: number) => ['/idea-views', id] as const,
};
